import React, { FC } from 'react';
import clsx from 'clsx';
import { DivLoader, SpinnerBlock, SpinnerBorder } from './styles';

interface Props {
  fixed?: boolean;
}

export const FnLoader: FC<Props> = ({ fixed }: Props) => {
  return (
    <>
      <DivLoader className={clsx('fn-loader-container', { ['fn-loader-fixed']: fixed })} />
      <SpinnerBlock className="fn-loader">
        <SpinnerBorder animation="border" />
      </SpinnerBlock>
    </>
  );
};
